module.exports = __webpack_public_path__ + "img/problem_stainless_steel.482dc106.svg";